export const HttpsProxyAgent = () => {
  return undefined;
};

export const ProxyAgent = undefined;
